<template>
  <div id="wrap">
    <Header
      :menus="topMenus"
      :selected-menu-id="selectedMenuId"
      @menu-change="handleMenuChange"
    />

    <div id="container">
      <div id="content" class="cont_wrap">
        <TopBar type="main" />
        <div class="cont_main main_culture">
          <div class="inr">
            <slot />
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script setup>
import '@/assets/css/main.css'
import { ref, computed, onMounted } from 'vue'
import { TopBar, Header, Footer } from '@/components/layout'
import { useApiMenu } from '@/composables/useApiMenu'
import { provideMenuContext } from '@/composables/useMenuContext'

defineOptions({ name: 'MainLayout' })

provideMenuContext()

const APP_NAME = '[관리자] 대구광역시 통합예약시스템'

const DOMAIN_ID = import.meta.env.VITE_DOMAIN_ID
const selectedMenuId = ref(null)

const { loadAllMenuData, getRootMenus } = useApiMenu()

const topMenus = computed(() => {
  return getRootMenus(DOMAIN_ID)
})

const handleMenuChange = (menuId) => {
  selectedMenuId.value = menuId
}

onMounted(async () => {
  const data = await loadAllMenuData(DOMAIN_ID)
  if (data && data.length > 0) {
    const roots = getRootMenus(DOMAIN_ID)
    if (roots.length > 0) {
      selectedMenuId.value = roots[0].menuId
    }
  }
  document.title = APP_NAME
})
</script>
